import React from 'react';
import './Education.css';

const Education = () => {
  const educationData = [
    {
      degree: "Doctor of Philosophy (Ph.D.) in Management",
      university: "Lingaya’s Vidyapeeth (Deemed to be University)",
      location: "Faridabad, Haryana",
      year: "Pursuing",
      status: "current",
      description: "Specializing in management research with focus on AI applications in business and education",
      icon: "🎓"
    },
    {
      degree: "MBA (HR & Marketing)",
      university: "AKTU Lucknow",
      college: "Kanpur Institute of Management Studies",
      location: "Kanpur",
      year: "2017",
      percentage: "First class",
      status: "completed",
      description: "Dual specialization in Human Resources and Marketing Management",
      icon: "📊"
    },
    {
      degree: "B.Sc. (Physics, Chemistry, Mathematics)",
      university: "CSJM University Kanpur",
      college: "Ram Janki Degree College",
      location: "Kanpur",
      year: "2015",
      percentage: "First class",
      status: "completed",
      description: "Foundation in science with focus on analytical and problem-solving skills",
      icon: "🔬"
    },
    {
      degree: "Intermediate (Science)",
      board: "U.P. Board",
      college: "Maharani Avanti Bai Inter College",
      location: "Kanpur",
      year: "2012",
      percentage: "First class",
      status: "completed",
      description: "Higher secondary education with science stream",
      icon: "📚"
    },
    {
      degree: "High School",
      board: "U.P. Board",
      college: "Baghpur Inter College",
      location: "Kanpur",
      year: "2010",
      percentage: "First class",
      status: "completed",
      description: "Secondary school education",
      icon: "🏫"
    }
  ];

  const certifications = [
    {
      name: "Diploma in Basic Computer",
      skills: "MS Office, Tally, DTP"
    },
    {
      name: "English Typing",
      skills: "25 WPM"
    }
  ];

  return (
    <section id="education" className="education-section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">Education & Qualifications</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            Academic journey and professional qualifications spanning over a decade of continuous learning
          </p>
        </div>

        {/* Education Timeline */}
        <div className="education-timeline">
          {educationData.map((edu, index) => (
            <div key={index} className={`timeline-item ${edu.status}`}>
              <div className="timeline-marker">
                <div className="marker-icon">
                  <span>{edu.icon}</span>
                </div>
                <div className="timeline-line"></div>
              </div>
              
              <div className="timeline-content">
                <div className="edu-card">
                  <div className="edu-header">
                    <h3 className="degree">{edu.degree}</h3>
                    <span className="year-badge">{edu.year}</span>
                  </div>
                  
                  <div className="edu-details">
                    <div className="institution">
                      <span className="university">{edu.university || edu.board}</span>
                      {edu.college && (
                        <span className="college">• {edu.college}</span>
                      )}
                    </div>
                    
                    <div className="location-duration">
                      <span className="location">📍 {edu.location}</span>
                    </div>
                    
                    {edu.percentage && (
                      <div className="performance">
                        <span className="percentage">{edu.percentage}</span>
                      </div>
                    )}
                    
                    <p className="edu-description">{edu.description}</p>
                    
                    {edu.status === "current" && (
                      <div className="current-status">
                        <span className="status-badge">Currently Pursuing</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Qualifications */}
        <div className="qualifications-section">
          <h3 className="qualifications-title">Additional Qualifications</h3>
          <div className="certifications-grid">
            {certifications.map((cert, index) => (
              <div key={index} className="certification-card">
                <div className="cert-icon">📜</div>
                <div className="cert-content">
                  <h4 className="cert-name">{cert.name}</h4>
                  <p className="cert-skills">{cert.skills}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Education Stats */}
        <div className="education-stats">
          <div className="stat-card">
            <div className="stat-number">5</div>
            <div className="stat-label">Degrees</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">8+</div>
            <div className="stat-label">Years in Education</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">3</div>
            <div className="stat-label">Universities</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">Continual</div>
            <div className="stat-label">Learning Journey</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;